import Breadcrumb from 'components/breadcrumb'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import LoadingScreen from 'components/loading-screen'
import { CAMPAIGNS } from './data'
import Slider from './componentes/Slider'

interface RouteParams {
  id: string
}

const Campaigns = () => {
  const { id } = useParams<RouteParams>()
  const [campaign, setCampaign] = useState<typeof CAMPAIGNS[0]>(null)

  const history = useHistory()

  useEffect(() => {
    const fetchEvent = async () => {
      if (!id) return history.push('/home')

      const data = CAMPAIGNS?.find((item) => item.id === id)
      setCampaign(data)
    }

    fetchEvent()
  }, [id])

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const imageUrl = windowWidth > 680 ? campaign?.desktopUrl : campaign?.mobileUrl

  const styles = {
    background: `url(${imageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  }

  if (!campaign) return <LoadingScreen />

  return (
    <div className="event-info-id">
      <div className="event-info-id__container" style={styles}>
        <div className="event-info-id__bc absolute">
          <Breadcrumb handleClick={() => history.goBack()} text="Campaña" />
        </div>
        <img src={imageUrl} className="w-full invisible event-info-id__image-campaign" />
        <div className="event-info-id__container-text absolute bottom-0 left-0 w-full">
          <h2 className="event-info-id__title mx-auto" style={{ maxWidth: '1388px' }}>{campaign.name}</h2>
        </div>
      </div>

      <div className="event-info-id__container__bottom mx-auto" style={{ maxWidth: '1408px' }}>

        <div className="event-info-id__bar" />

        <p className="event-info-id__text">{campaign.description ?? 'Sin información'}</p>

        <div className="event-info-id__bar" />

        {campaign.youtube && (
          <iframe width="560" height="315" className='w-full h-auto max-w-2xl mx-auto' style={{ aspectRatio: '16/9' }} src={campaign.youtube} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        )}
        {campaign.slider && (
          <Slider data={campaign.slider.map(slide => ({...slide, type: slide.type as "image" | "video"}))} />
        )}
      </div>
    </div>
  )
}

export default Campaigns
